/**
 * External dependencies
 */
import type { ReactNode } from 'react';

export type VisuallyHiddenProps = {
	/**
	 * The children elements.
	 */
	children: ReactNode;
};
